import { UiSchema } from '@rjsf/core';
import { JSONSchema7 } from 'json-schema';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IntakeForm } from 'views/pages/client-record/useIntakeForm';
import JsonFormContainer from '../JsonFormContainer';
import Actions from './Actions';

const uiSchema: UiSchema = {};

interface Props {
  intakeForm: IntakeForm;
  onPrevious?: () => void;
  isSubmitting: boolean;
  onSubmit: (data: any) => void;
  handleStep?: any;
}

export default function EducationalHistory({ intakeForm, onPrevious, isSubmitting, onSubmit, handleStep }: Props) {
  const intl = useIntl();
  const schema: JSONSchema7 = {
    type: 'object',
    title: intl.formatMessage({ defaultMessage: 'Educational History' }),
    properties: {
      educationalHistory_1: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Highest Grade Completed?' })
      },
      educationalHistory_2: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Where?' })
      },
      educationalHistory_3: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Did you attend college?' })
      },
      educationalHistory_4: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Where?' })
      },
      educationalHistory_5: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Major?' })
      },
      educationalHistory_6: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What is your highest degree attained?' })
      }
    }
  };
  const [formData, setFormData] = useState(intakeForm.educationalHistory);

  return (
    <JsonFormContainer
      noValidate
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={({ formData }) => {
        handleStep({
          educationalHistory: formData
        });
        setFormData(formData);
      }}
      onSubmit={({ formData }) =>
        onSubmit({
          educationalHistory: formData
        })
      }
    >
      <Actions onPrevious={onPrevious} disabled={isSubmitting} />{' '}
    </JsonFormContainer>
  );
}
